<div class="assistant-standalone-page">
    <BolideAssistant
        :is_open="true"
        :standalone="true"
        @close-assistant="go_back"
    />
</div>
